import { connect } from 'react-redux'

import * as actions from '../actions'
import * as selectors from '../selectors'
import ValidateRegistration from '../components/ValidateRegistration'


const mapStateToProps = (state, routeParams) => {
    return {
        hash: routeParams.params.hash,
        validating: selectors.isValidatingRegistration(state),
        validated: selectors.validatedRegistration(state),
        validationFailed: selectors.registrationValidationFailed(state),
        token: selectors.getToken(state)
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onValidate: hash => dispatch(actions.validateRegistration(hash))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ValidateRegistration)



/** WEBPACK FOOTER **
 ** ./src/containers/ValidateRegistrationContainer.js
 **/